import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/Router';

const useNavigateForm = () => {
  const navigate = useNavigate();

  const goToRecovery = () => {
    navigate(ROUTES.auth.recovery);
  };

  const goToSignup = () => {
    window.location.assign('https://www.creditas.com/parceiros');
  };

  const goToLogin = () => {
    navigate(ROUTES.auth.login);
  };

  const goToPostNewPassword = () => {
    navigate(ROUTES.auth.postNewPassword);
  };

  const goToProposals = () => {
    window.location.assign(ROUTES.proposals);
  };

  const goToAutofinLogin = (queryParams?: any) => {
    if (queryParams) {
      const qs = Object.keys(queryParams)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');

      window.location.assign(`${process.env.REACT_APP_AUTOFIN_LOGIN_PAGE}?${qs}`);
    } else {
      window.location.assign(process.env.REACT_APP_AUTOFIN_LOGIN_PAGE);
    }
  };

  return {
    goToLogin,
    goToSignup,
    goToRecovery,
    goToProposals,
    goToAutofinLogin,
    goToPostNewPassword,
  };
};

export { useNavigateForm };
